import React from "react";

export const ScreenContext = React.createContext();

export function ScreenContextProvider({
  initState = { totalScreen: 0, zMap: {} },
  children = null,
}) {
  const [store, dispatch] = React.useReducer((state, { type, value }) => {
    switch (type) {
      case "init-z-index": {
        if (value.screen in state.zMap) return state;
        // atBottom slides the new screen under the stack so registering
        // after the initial mount cannot steal the front position
        const zMap = value.atBottom
          ? Object.fromEntries(
              Object.values(state.zMap).map((s) => {
                return [s.screen, { ...s, z: s.z + 1 }];
              })
            )
          : { ...state.zMap };
        return {
          ...state,
          totalScreen: state.totalScreen + 1,
          zMap: {
            ...zMap,
            [value.screen]: {
              screen: value.screen,
              z: value.atBottom ? 1 : state.totalScreen + 1,
            },
          },
        };
      }
      case "remove-z-index": {
        if (!(value.screen in state.zMap)) return state;
        const remaining = Object.values(state.zMap)
          .filter((s) => {
            return s.screen !== value.screen;
          })
          .sort((a, b) => {
            return a.z - b.z;
          });
        return {
          ...state,
          totalScreen: state.totalScreen - 1,
          zMap: Object.fromEntries(
            remaining.map((s, i) => {
              return [s.screen, { ...s, z: i + 1 }];
            })
          ),
        };
      }
      case "set-z-index":
        return { ...state, zMap: value };
      default:
        return initState;
    }
  }, initState);

  return (
    <ScreenContext.Provider value={{ dispatch, store }}>
      {children}
    </ScreenContext.Provider>
  );
}

export function WithScreenContextProvider(WrappedComponent) {
  return (props) => {
    return (
      <ScreenContextProvider>
        <WrappedComponent {...props} />
      </ScreenContextProvider>
    );
  };
}

export default WithScreenContextProvider;
